/* ================================================================
   Persona Free-Shipping → Rebuy Smart Cart progress bar unlock
   ----------------------------------------------------------------
   When the cart carries _offer containing "Free Shipping" (the same
   condition the Persona Free Shipping discount function checks at
   checkout), set the Rebuy progress bar's free-shipping tier minimum
   to 0 so Rebuy's own tier logic renders the native "unlocked" state.

   Mirrors: viori-bundle-discount/extensions/free-shipping-function/
            src/run.js — cart attribute _offer, substring "Free Shipping".

   Does NOT check first-time-buyer (that's a checkout-side guard; the
   bar is a visual hint — the function handles the actual gating).
   ================================================================ */
(function () {
  'use strict';

  var applied = false;

  function isEligible(cart) {
    if (!cart || !cart.attributes) return false;
    var offer = cart.attributes._offer || cart.attributes['_offer'] || '';
    return offer.indexOf('Free Shipping') !== -1;
  }

  function unlockBar() {
    if (typeof Rebuy === 'undefined' || !Rebuy.SmartCart) return false;

    // New API: getProgressBarSettings — real shape is { bars: [ { tiers: [...] } ] }
    // and the shipping tier's type is "shipping" (not "free_shipping").
    if (typeof Rebuy.SmartCart.getProgressBarSettings === 'function') {
      var settings = Rebuy.SmartCart.getProgressBarSettings();
      if (settings) {
        var bars = settings.bars || (settings.tiers ? [settings] : []);
        var changed = false;
        for (var b = 0; b < bars.length; b++) {
          var tiers = bars[b].tiers || [];
          for (var i = 0; i < tiers.length; i++) {
            if (tiers[i].type === 'shipping' || tiers[i].type === 'free_shipping') {
              tiers[i].minimum = 0;
              changed = true;
            }
          }
        }
        if (changed) return true;
      }
    }

    // Legacy fallback: direct settings object
    if (Rebuy.SmartCart.settings && Rebuy.SmartCart.settings.free_shipping) {
      Rebuy.SmartCart.settings.free_shipping.minimum = 0;
      return true;
    }

    return false;
  }

  function check() {
    if (applied) return;
    try {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (applied) return;
          if (!isEligible(cart)) return;
          if (unlockBar()) {
            applied = true;
          }
        })
        .catch(function () {});
    } catch (e) { /* silent */ }
  }

  document.addEventListener('rebuy:smartcart.init', check);
  document.addEventListener('rebuy:cart.change', check);

  // Also try on DOMContentLoaded in case Rebuy inits before our listeners
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(check, 500);
    });
  } else {
    setTimeout(check, 500);
  }
})();
